<template>
  <div
    id="container"
    class="fixed bottom-0 left-0 right-0 bg-surface text-primary py-3 px-4 border-t-2 border-status-info z-50 theme-transition backdrop-blur"
    :class="{ hidden: isDismissed }"
  >
    <div
      class="container mx-auto flex flex-col items-center justify-between gap-3"
    >
      <p class="text-sm/6 text-center text-primary">
        <span class="mr-1">🔒</span>
        <span class="font-medium">{{ $t("cookiesDisclaimer.title") }}</span>
        <br />
        <span class="text-secondary font-normal">
          {{ $t("cookiesDisclaimer.message.preCompany") }}
        </span>
        <span class="text-primary font-medium">
          {{ $t("cookiesDisclaimer.message.company") }}
        </span>
        <span class="text-secondary font-normal">
          {{ $t("cookiesDisclaimer.message.postCompany") }}
        </span>
        <br />
        <span class="font-medium text-primary">
          {{ $t("cookiesDisclaimer.noTracking") }}
        </span>
        <span class="text-secondary font-normal">
          {{ $t("cookiesDisclaimer.learnMore.preLink") }}
        </span>
        <router-link
          to="/cookies-policy"
          class="text-invertedAlt hover:text-inverted focus:text-inverted focus:underline hover:underline transition-colors"
        >
          {{ $t("cookiesDisclaimer.learnMore.link") }}
        </router-link>
        <span class="text-secondary font-normal">
          {{ $t("cookiesDisclaimer.learnMore.postLink") }}
        </span>
      </p>
      <button
        @click="dismiss"
        class="flex items-center gap-2 px-4 py-2 bg-brand-darkblue border-brand-yellow font-medium text-white rounded-lg border hover:text-brand-yellow focus:text-brand-yellow transition-colors duration-200 whitespace-nowrap"
      >
        <span class="text-lg !duration-0 select-none">✓</span>
        {{ $t("cookiesDisclaimer.understood") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDismissed: false,
    };
  },
  computed: {
    policyLink() {
      return this.$t("common.nav.cookiesPolicy");
    },
    formattedMessage() {
      const companyName = `<span class="font-medium text-primary">${this.$t("common.company.name")}</span>`;
      return this.$t("cookiesDisclaimer.message", { company: companyName });
    },
  },
  mounted() {
    this.isDismissed =
      localStorage.getItem("cookiesDisclaimerDismissed") === "true";
  },
  methods: {
    dismiss() {
      localStorage.setItem("cookiesDisclaimerDismissed", "true");
      this.isDismissed = true;
    },
  },
};
</script>

<style scoped>
#container {
  box-shadow: 0 -33px 67px #004aad;
}
</style>
